"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getDefaultMotionState: function() {
        return _hooks.getDefaultMotionState;
    },
    useMotion: function() {
        return _hooks.useMotion;
    },
    useMotionClassNames: function() {
        return _hooks.useMotionClassNames;
    }
});
const _hooks = require("./hooks");
